import React from "react";
import {
  useRetrieveProjectResourcesTags,
  useRetrieveResourcesTags,
} from "@planzone/view-models";
import { useWorkspaceContext } from "@scenes/workspaceContext";

// The tags of the project members inside a project, of every planzone resource otherwise.
function useResourceTags() {
  const ctx = useWorkspaceContext();
  const project = ctx.type === "project" ? ctx.project : undefined;
  const planzoneTags = useRetrieveResourcesTags();
  const projectTags = useRetrieveProjectResourcesTags();

  // The project tags kept since the last opening are shown again, unless another project is opened.
  React.useEffect(() => {
    if (project)
      (projectTags.projectUuid !== project.uuid ||
        projectTags.isRequestFailure) &&
        projectTags.retrieveProjectResourcesTags(project);
    else
      !planzoneTags.isRequestPending &&
        !planzoneTags.isRequestSuccess &&
        !planzoneTags.isRequestFailure &&
        planzoneTags.retrieveResourcesTags();
  }, [project?.uuid]);

  React.useEffect(() => {
    project &&
      projectTags.isDirty &&
      projectTags.projectUuid === project.uuid &&
      !projectTags.isRequestPending &&
      projectTags.retrieveProjectResourcesTags(project);
  }, [projectTags.isDirty, projectTags.isRequestPending]);

  return project
    ? { isRequestPending: projectTags.isRequestPending, tags: projectTags.tags }
    : {
        isRequestPending: planzoneTags.isRequestPending,
        tags: planzoneTags.tags,
      };
}

export { useResourceTags };
